import { Button } from "@/_component/Common";
import { useLanguageContext } from "@/hooks";

export default function AddonPlanDropdown({ addonPlans, item, onChoosePlan, dropdownPlaceholder="label.choose_plan" }) {
    const { language } = useLanguageContext();

    const renderAddonPlan = (item) => {
        const addonPlan = addonPlans[item.additionalPlanId];
        if (addonPlan) {
            return `${language('label.plan')}${addonPlan.tenure} - ₹${item.withGreatDealBanner ? addonPlan.greatDealBannerPrice : addonPlan.price}`;
        }
        return <span>{language(dropdownPlaceholder)}</span>;
    }

    return (
        <Button secondary outline rounded small noSpacing className="px-2 py-2" onClick={() => onChoosePlan(item, item.withGreatDealBanner)} >
            {renderAddonPlan(item)}
            <i className="bi bi-caret-down-fill ms-2"></i>
        </Button>
    );
}